import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { tokens } from '@everfi/design-system';
import { FAIcon } from '../../fa-icon/component.js';
import { dataAttribsForEl } from '../../../utils/dataAttribsForEl.js';
import { Layout } from '../../../core/components/Layout/component.js';
import { Icon } from '../../../core/components/Icon/component.js';
import { Typography } from '../../../core/components/Typography/component.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
var CardTitle = function CardTitle(props) {
  var chakra = props.chakra,
    children = props.children,
    className = props.className,
    icon = props.icon,
    _props$iconSize = props.iconSize,
    iconSize = _props$iconSize === void 0 ? 'medium' : _props$iconSize,
    size = props.size,
    _props$titleDataAttri = props.titleDataAttributes,
    _props$titleDataAttri2 = _props$titleDataAttri === void 0 ? {} : _props$titleDataAttri,
    _props$titleDataAttri3 = _props$titleDataAttri2.context,
    context = _props$titleDataAttri3 === void 0 ? {} : _props$titleDataAttri3,
    optionalAttributes = _props$titleDataAttri2.optionalAttributes,
    type = props.type,
    secondaryDetail = props.secondaryDetail,
    attentionGrabber = props.attentionGrabber,
    isDismissable = props.isDismissable;
  var dataAttributes = dataAttribsForEl(context, optionalAttributes);
  var TitleTag = type === 'mini' ? 'h4' : 'h3';
  var iconSizes = {
    small: 'sm',
    medium: 'md',
    large: 'lg',
    extralarge: 'xl'
  };
  return chakra === 'on' ? /*#__PURE__*/React.createElement(Layout, dataAttributes, /*#__PURE__*/React.createElement(Layout, {
    paddingRight: isDismissable ? tokens.SpacingBaseLg : 0,
    variant: "flex",
    flexDirection: "row",
    alignItems: "flex-start"
  }, icon && /*#__PURE__*/React.createElement(Layout, {
    paddingRight: tokens.SpacingBaseSm,
    variant: "flex",
    alignItems: "center",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Icon, {
    iconName: icon,
    size: iconSizes[iconSize]
  })), /*#__PURE__*/React.createElement(Typography, {
    "data-action": "card-title",
    variant: TitleTag,
    style: {
      marginTop: 0
    }
  }, children)), secondaryDetail, attentionGrabber) : /*#__PURE__*/React.createElement(TitleTag, _extends({
    className: _formatClassName(['card-title', "card-title-".concat(size), 'm-t-0', className])
  }, dataAttributes, {
    "data-action": "card-title"
  }), icon && /*#__PURE__*/React.createElement(FAIcon, {
    icon: icon,
    size: iconSize,
    additionalClasses: "title-icon"
  }), children);
};
CardTitle.displayName = 'CardTitle';
export { CardTitle };